export default __webpack_public_path__ + "static/media/perm.21ea379a.png";